import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import storageService from "../../Services/storageService";
import "./Checkout.css";
import { useTranslation } from "react-i18next";
import Confetti from "react-confetti";
import toastr from "toastr";
import { currency, promotionNames } from "../../utils/currency";
import dayjs from "dayjs";
import {
  addHoursToTime,
  couponHotels,
  EXCLUDE_DISCOUNT_ROOM,
  getFixedValue,
  sourceTest,
} from "../../utils/utils";
import { fireGtmEvent } from "../../utils/googleAnalytics";
import usePriceCalculator, {
  arrangePromos,
  calculatePromotion,
  getApplicablePromotion,
} from "../../utils/usePriceCalculator";
import useOldPriceCalculator from "../../utils/useOldPriceCalculator";

const Checkout = ({
  extraPrice = 1,
  localExtraValue = 1.15,
  onClose = () => {},
  showFakePrice = false,
}) => {
  const [totalCost, setTotalCost] = useState();
  const [totalDays, setTotalDays] = useState(1);
  const [applyOffer, setApplyOffer] = useState(0);
  const [promotionSelected, setPromotionSelected] = useState({});
  const [promotionPrice, setPromotionPrice] = useState();
  const [applicablePromo, setApplicablePromo] = useState();
  const [isOffer, setIsOffer] = useState(false);
  const [priceWODiscount, setPriceWODiscount] = useState();
  const [selectedPeople, setSelecedPeople] = useState();
  const [roomPriceMap, setRoomPriceMap] = useState();
  const [taxAmount, setTaxAmount] = useState(0);
  const [arrangedPromos, setArrangedPromos] = useState([]);

  const history = useHistory();

  const testId = storageService.get("testId") || 0;

  const oldPriceCalculator = useOldPriceCalculator();

  const { t } = useTranslation();

  const {
    selectedRooms,
    selectedAddons,
    hotelData,
    selectedHotelAddons,
    dateRange,
    totalPeople,
    promotions,
    totalAdult,
    isHourlyRoom,
    selectedRatePlans,
    roomSlots,
    hourlyTime,
    hourlyDate,
    hourlyHour,
    dateCount,
    isRatePlans,
  } = useSelector((state) => state.hotelInfo);

  useEffect(() => {
    let arr = [...promotions];
    arr.sort((b, a) => a.discount - b.discount);
    setApplicablePromo(arr);
  }, [promotions]);

  useEffect(() => {
    const arrange = () => {
      let arr = [...promotions];
      let ar = arrangePromos(arr);
      setArrangedPromos(ar);
    };
    promotions?.length > 0 && arrange();
  }, [
    promotions,
    selectedAddons,
    selectedHotelAddons,
    selectedRooms,
    totalAdult,
  ]);

  useEffect(() => {
    calculateDiscount();
  }, [applyOffer]);

  const promoShown = storageService.get("isPromoShown") || false;

  const priceCalculator = usePriceCalculator();

  const calculateDiscount = () => {
    if (isRatePlans) {
      return;
    }

    let roomPrice = 0;
    let noDiscPrice = 0;

    if (isHourlyRoom) {
      storageService.remove("discount");
      storageService.remove("promo");
      return;
    }

    selectedRooms?.map((rm) => {
      const { pricing = [], priceConfig = {}, priceConfigDifference = {} } = rm;
      let val1 =
        totalAdult <= rm?.defaultGuestCount
          ? totalAdult
          : rm?.defaultGuestCount;

      // remove stuff
      if (testId === 0) {
        val1 = rm?.sAdult;
      }
      let prVal = 0;
      // end remove stuff
      if (
        priceConfigDifference &&
        Object.keys(priceConfigDifference).length > 0
      ) {
        pricing.forEach((pr) => {
          // roomPrice +=
          //   parseFloat(pr?.price) + parseFloat(priceConfigDifference[val1]) ||
          //   1;
          prVal += parseFloat(pr?.price);
          if (EXCLUDE_DISCOUNT_ROOM.includes(rm?.id)) {
            noDiscPrice +=
              parseFloat(pr.price) * (parseFloat(priceConfig[val1]) || 1);
          } else if (hotelData?.userId === 63809) {
            let prc = pr?.price;
            prc = prc > 8400 ? prc / 1.18 : prc / 1.12;
            roomPrice += parseFloat(prc) * (parseFloat(priceConfig[val1]) || 1);
          } else {
            roomPrice +=
              parseFloat(pr.price) * (parseFloat(priceConfig[val1]) || 1);
          }
        });
      } else {
        pricing.forEach((pr) => {
          prVal += parseFloat(pr.price);
          if (EXCLUDE_DISCOUNT_ROOM.includes(rm?.id)) {
            noDiscPrice +=
              parseFloat(pr.price) * (parseFloat(priceConfig[val1]) || 1);
          } else if (hotelData?.userId === 63809) {
            let prc = pr?.price;
            prc = prc > 8400 ? prc / 1.18 : prc / 1.12;
            roomPrice += parseFloat(prc) * (parseFloat(priceConfig[val1]) || 1);
          } else {
            roomPrice +=
              parseFloat(pr.price) * (parseFloat(priceConfig[val1]) || 1);
          }
        });
      }

      // remove stuff
      if (testId === 0) {
        if (rm?.sInfant) {
          roomPrice =
            roomPrice + rm?.extraInfantPrice * rm?.sInfant * dateCount;
        }

        if (rm?.sChild) {
          roomPrice = roomPrice + rm?.extraChildPrice * rm?.sChild * dateCount;
        }
      }
      // end remove stuff

      // pricing.forEach((pr) => {
      //   roomPrice =
      //     roomPrice +
      //     parseFloat(pr?.price) * (parseFloat(rm?.priceConfig[val1]) || 1);
      // });
    });

    selectedAddons?.forEach((adn) => {
      if (adn?.Addon?.category === "person") {
        roomPrice =
          roomPrice +
          parseInt(adn?.price) *
            // selectedRooms?.filter((rm) => rm?.id === adn?.hotelRoomId)?.length *
            selectedRooms[0]?.pricing?.length;
      }
    });

    let promoApplied = null;
    let discountAmount = 0;
    let finalAmount = 0;
    let cost = 0;

    if (applicablePromo?.length > 0 && promotions) {
      applicablePromo?.forEach((promo) => {
        if (!promoApplied) {
          if (
            promo?.type === "bulk" &&
            totalCost >= parseFloat(promo?.cutoffAmount)
          ) {
            cost = totalCost;
            discountAmount = (cost * parseFloat(promo?.discount)) / 100;
            finalAmount = cost - discountAmount;
            promoApplied = promo;
            setPromotionSelected(promoApplied);
            !storageService.get("promo") && setIsOffer(true);

            setTimeout(() => {
              setIsOffer(false);
              storageService.set("isPromoShown", true);
            }, 5000);
            // storageService.set("promo", promoApplied);
            setTotalCost(finalAmount);
            setPriceWODiscount(discountAmount);
          } else if (promo?.type === "early" || promo?.type === "late") {
            cost = roomPrice;
            discountAmount = (cost * parseFloat(promo?.discount)) / 100;
            finalAmount = cost - discountAmount;
            promoApplied = promo;
            setPromotionSelected(promoApplied);
            !storageService.get("promo") && setIsOffer(true);
            setTimeout(() => {
              setIsOffer(false);
              storageService.set("isPromoShown", true);
            }, 5000);
            // storageService.set("promo", promoApplied);
            storageService.set("discountedValue", discountAmount);
            if (hotelData?.userId === 63809) {
              setTotalCost(finalAmount);
            } else {
              setTotalCost(parseFloat(totalCost - roomPrice + finalAmount));
            }

            setPriceWODiscount(discountAmount);
          } else {
            storageService.remove("promo");
            setPromotionSelected({});
            setTotalCost(totalCost);
          }
        }
      });
      setPromotionPrice(parseFloat(finalAmount));
      promoApplied && storageService.set("discount", parseFloat(finalAmount));
    } else {
      setPromotionPrice(0);
      storageService.set("discount", 0);
    }
  };

  // done
  useEffect(() => {
    const computeRoomPriceObj = () => {
      const roomPriceObj = new Map();
      selectedRooms?.forEach((room) => {
        let onedayprice = 0;
        const {
          pricing = [],
          defaultGuestCount,
          id,
          priceConfig = {},
          priceConfigDifference = {},
        } = room;
        let val1 =
          totalAdult <= defaultGuestCount ? totalAdult : defaultGuestCount;
        // remove stuff
        if (testId === 0) {
          val1 = room?.sAdult;
        }
        let prVal = 0;
        // end remove stuff
        if (
          priceConfigDifference &&
          Object.keys(priceConfigDifference).length > 0
        ) {
          pricing.forEach((pr) => {
            let temp = pr?.price;
            if (hotelData?.userId === 63809) {
              temp = temp > 8400 ? temp / 1.18 : temp / 1.12;
            }
            onedayprice +=
              parseFloat(temp) + parseFloat(priceConfigDifference[val1]) || 1;
            prVal += parseFloat(temp);
          });
        } else {
          pricing.forEach((pr) => {
            let temp = pr?.price;
            if (hotelData?.userId === 63809) {
              temp = temp > 8400 ? temp / 1.18 : temp / 1.12;
            }
            onedayprice +=
              parseFloat(temp) * (parseFloat(priceConfig[val1]) || 1);
            prVal += parseFloat(temp);
          });
        }

        // remove stuff
        if (testId === 0) {
          if (room?.sInfant) {
            onedayprice =
              onedayprice + room?.extraInfantPrice * room?.sInfant * dateCount;
          }

          if (room?.sChild) {
            onedayprice =
              onedayprice + room?.extraChildPrice * room?.sChild * dateCount;
          }
        }
        // end remove stuff
        // pricing.forEach((pr) => {
        //   onedayprice =
        //     onedayprice +
        //     parseFloat(pr?.price) *
        //       (parseFloat(priceConfig[val1]) || defaultGuestCount);
        // });

        onedayprice = onedayprice / pricing?.length;

        // console.log("oneday", onedayprice);
        // if (parseFloat(promotionSelected?.discount)) {
        //   onedayprice =
        //     onedayprice -
        //     (onedayprice * parseFloat(promotionSelected?.discount)) / 100;
        //   console.log("oneday", onedayprice);
        // }

        if (roomPriceObj.has(room?.id)) {
          let val = roomPriceObj.get(room?.id);
          val += onedayprice;
          roomPriceObj.set(room?.id, val);
        } else {
          roomPriceObj.set(room?.id, onedayprice);
        }
      });

      selectedAddons?.forEach((addon) => {
        if (
          addon?.Addon?.category === "person" &&
          roomPriceObj.has(addon?.hotelRoomId)
        ) {
          let val = roomPriceObj.get(addon?.hotelRoomId);
          val += parseFloat(addon?.price);
          roomPriceObj.set(addon?.hotelRoomId, val);
        }
      });

      // setRoomPriceMap(roomPriceObj);
    };
    computeRoomPriceObj();
  }, [selectedRooms, selectedAddons, promotionSelected]);

  // done
  useEffect(() => {
    const calculateTaxPrice = () => {
      let sum = 0;
      for (let [key, value] of roomPriceMap) {
        let rmCount = selectedRooms?.filter((rm) => rm?.id === key)?.length;
        let taxAmount = 0;

        if (
          parseFloat(promotionSelected?.discount) &&
          !EXCLUDE_DISCOUNT_ROOM.includes(key)
        ) {
          value =
            value - (value * parseFloat(promotionSelected?.discount)) / 100;
        }

        if (
          hotelData?.userId === 63809 &&
          parseFloat(promotionSelected?.discount) > 0
        ) {
          if (value / rmCount > 7500) {
            taxAmount = value * 1.18 - value;
          } else {
            taxAmount = value * 1.12 - value;
          }
        } else {
          if (value / rmCount > 8400) {
            taxAmount = value - value / 1.18;
          } else {
            taxAmount = value - value / 1.12;
          }
        }

        sum += taxAmount;
      }
      sum = sum * selectedRooms[0]?.pricing?.length;

      storageService.set(
        "tax",
        parseFloat(sum.toFixed(getFixedValue(hotelData?.currency)))
      );
      setTaxAmount(sum.toFixed(getFixedValue(hotelData?.currency)));
    };
    typeof roomPriceMap === "object" &&
      hotelData?.currency === "INR" &&
      !isHourlyRoom &&
      calculateTaxPrice();
  }, [roomPriceMap]);

  useEffect(() => {
    const calculateCost = () => {
      var prices = 0;

      var totalPeople = 0;
      let arrPromos = [...arrangedPromos];
      let arr = [],
        totalTax = 0,
        roomCost = 0;

      selectedRooms?.forEach((room) => {
        const {
          pricing = [],
          defaultGuestCount,
          id,
          priceConfig = {},
          priceConfigDifference = {},
        } = room;
        let val =
          totalAdult <= defaultGuestCount ? totalAdult : defaultGuestCount;

        // remove stuff
        if (testId === 0) {
          val = room?.sAdult;
        }
        let prVal = 0;
        // end remove stuff
        let totPrice = 0;

        pricing.forEach((pr, idx) => {
          let prc = pr?.price;
          let tempPrice = 0;
          if (hotelData?.userId === 63809) {
            prc = prc > 8400 ? prc / 1.18 : prc / 1.12;
          }
          tempPrice += parseFloat(prc) * (parseFloat(priceConfig[val]) || 1);
          if (room?.sInfant) {
            tempPrice += room?.extraInfantPrice * room?.sInfant;
          }

          if (room?.sChild) {
            tempPrice += room?.extraChildPrice * room?.sChild;
          }

          prVal += parseFloat(prc);

          const promo = getApplicablePromotion({
            arrangedPromos: arrPromos,
            rp: { roomId: room?.id },
            tempPrice,
            checkInDate: pr?.date,
          });

          let { finalValue, reducedPrice } = calculatePromotion({
            price: tempPrice,
            promo,
            idx,
            dateCount,
          });

          totPrice += tempPrice;
        });

        if (isHourlyRoom) {
          let slotObj = roomSlots[id];

          // remove stuff
          if (testId === 0) {
            if (room?.sAdult <= room?.defaultGuestCount) {
              prices += prVal * slotObj?.percentage;
            } else {
              if (
                priceConfigDifference &&
                Object.keys(priceConfigDifference).length > 0
              ) {
                prices =
                  prices +
                  prVal * slotObj?.percentage +
                  priceConfigDifference[room?.sAdult];
              } else {
                prices =
                  prices +
                  prVal * priceConfig[room?.sAdult] * slotObj?.percentage;
              }
            }
          } else {
            prices += totPrice * slotObj?.percentage;
          }
          // remove stuff end
        } else {
          prices += totPrice;
        }

        setTotalDays(pricing?.length);
      });

      selectedAddons?.forEach((addon) => {
        // const { price = "0" } = addon;
        if (addon?.Addon?.category === "meal") {
          prices =
            prices +
            parseFloat(addon?.price) * selectedRooms[0]?.pricing?.length;
        } else if (addon?.Addon?.category === "person") {
          prices =
            prices +
            parseFloat(addon?.price) * selectedRooms[0]?.pricing?.length;
        }
      });

      selectedHotelAddons?.forEach((adn) => {
        if (adn.Addon.multiplier === "per_day") {
          prices +=
            parseFloat(adn.price) *
            dayjs(dateRange?.endDate)?.diff(dateRange?.startDate, "days");
        } else {
          prices += parseFloat(adn.price);
        }
      });

      if (selectedRooms?.length < 1) {
        storageService.remove("promo");
      }
      setTotalCost(parseFloat(prices));
      setApplyOffer(applyOffer + 1);

      // maybe add

      storageService.set("totalPrice", parseFloat(prices));
    };
    calculateCost();
  }, [
    selectedAddons,
    selectedHotelAddons,
    selectedRooms,
    totalAdult,
    roomSlots,
    arrangedPromos,
  ]);

  const sendAnalytics = () => {
    if (selectedRooms?.length > 0 || priceCalculator.selectedRooms.length > 0) {
      history.push("/room/checkout", {
        discount: promotionPrice,
        promo: promotionSelected,
      });
    } else {
      toastr.error(t("select_at_least_one_room"));
    }
  };

  useEffect(() => {
    var count = 0;
    selectedRooms?.forEach((room) => {
      let searchGuest =
        totalAdult <= room?.defaultGuestCount
          ? totalAdult
          : room?.defaultGuestCount;

      // remove stuff
      if (testId === 0) {
        count += room?.sAdult + room?.sChild + room?.sInfant;
      } else {
        count += searchGuest;
      }

      // end remove stuff
    });
    [...new Set(selectedRooms)]?.forEach((room) => {
      selectedAddons?.forEach((addon) => {
        if (
          addon?.Addon?.category === "person" &&
          room?.id === addon?.hotelRoomId
        )
          count++;
      });
    });
    setSelecedPeople(count);
  }, [selectedAddons, selectedRooms]);

  useEffect(() => {
    if (isRatePlans) {
      setSelecedPeople(priceCalculator.rpTotalGuest || 0);
    } else {
      setSelecedPeople(oldPriceCalculator.totalGuests || 0);
    }
  }, [priceCalculator, oldPriceCalculator]);

  const isSubscribed = storageService.get("subscribed") || false;

  const isGoogle = sourceTest.includes(storageService.get("source"));

  return (
    <div className="checkout">
      {(priceCalculator.appliedDiscount.discount > 0 ||
        oldPriceCalculator.appliedDiscount.discount > 0) &&
      (selectedRooms?.some((rm) => !EXCLUDE_DISCOUNT_ROOM.includes(rm?.id)) ||
        isRatePlans) ? (
        <div className="checkout__promorSelected">
          {t("you_got")} {currency(hotelData?.currency)}{" "}
          {parseFloat(
            (priceCalculator.appliedDiscount.discount ||
              oldPriceCalculator.appliedDiscount.discount) * localExtraValue
          ).toFixed(getFixedValue(hotelData?.currency))}{" "}
          {isSubscribed ? "+ 15% " : ""}
          {t("off")}!!{" "}
          {couponHotels.includes(hotelData?.id) ? t("code_mount_applied") : " "}
          {/* `${promotionNames[promotionSelected?.type]} ${t("applied")}.` */}
        </div>
      ) : isSubscribed && showFakePrice ? (
        <div className="checkout__promorSelected">
          {t("additional_15_percent_off_applied")}
        </div>
      ) : null}

      <div className="checkout__container">
        <div className="checkout__price">
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              flexWrap: "wrap",
              gap: "10px",
            }}
          >
            {currency(hotelData?.currency)}{" "}
            {isRatePlans
              ? (priceCalculator.appliedDiscount.discount > 0
                  ? priceCalculator.priceAfterDiscount * extraPrice
                  : priceCalculator.rpPrice * extraPrice
                ).toFixed(getFixedValue(hotelData?.currency))
              : (oldPriceCalculator.totalPrice * extraPrice).toFixed(
                  getFixedValue(hotelData?.currency)
                )}
            {isRatePlans ? (
              priceCalculator.rpTax > 0 ||
              priceCalculator.taxObj.totalBookingTax > 0 ? (
                <p>
                  {" "}
                  +{" "}
                  {Number(
                    (priceCalculator.rpTax +
                      priceCalculator.taxObj.totalBookingTax) *
                      extraPrice
                  ).toFixed(getFixedValue(hotelData?.currency))}{" "}
                  ({t("taxes")})
                </p>
              ) : (
                <p> ({t("incl_of_taxes")})</p>
              )
            ) : Math.abs(oldPriceCalculator?.totalTax) > 0 ||
              oldPriceCalculator.taxObj?.totalBookingTax > 0 ? (
              <p>
                {" "}
                +{" "}
                {(
                  (Math.abs(oldPriceCalculator?.totalTax) +
                    oldPriceCalculator.taxObj?.totalBookingTax) *
                  extraPrice
                ).toFixed(getFixedValue(hotelData?.currency))}{" "}
                {t("taxes")}
              </p>
            ) : (
              <p> ({t("incl_of_taxes")})</p>
            )}
            {isHourlyRoom && (
              <p>
                ( {t("upto")}{" "}
                {oldPriceCalculator.totalGuests || priceCalculator.rpTotalGuest}{" "}
                {t("guests")} )
              </p>
            )}
          </div>
          {!isHourlyRoom && (
            <p>
              {dateCount > 1
                ? `${t("for")} ${dateCount} ${t("nights")}`
                : t("per_night")}{" "}
              - {t("upto")}{" "}
              {oldPriceCalculator.totalGuests || priceCalculator.rpTotalGuest}{" "}
              {t("guests")}
            </p>
          )}
          {isHourlyRoom && (
            <p style={{ fontSize: "14px" }}>
              {dayjs(hourlyDate).format("DD MMMM YYYY")}
            </p>
          )}
          {isHourlyRoom ? (
            <>
              <span style={{ fontSize: "14px" }}>
                {hourlyTime} -{" "}
                {addHoursToTime(hourlyDate, hourlyTime, hourlyHour)}
              </span>
            </>
          ) : (
            <span style={{ fontSize: "12px" }}>
              {dayjs(dateRange?.startDate).format("DD MMM")} -{" "}
              {dayjs(dateRange?.endDate).format("DD MMM")} ({dateCount}{" "}
              {dateCount > 1 ? t("nights") : t("night")})
            </span>
          )}
        </div>
        <div className="checkoutBtn">
          <div
            to="/room/checkout"
            className="checkout__button"
            onClick={sendAnalytics}
          >
            {t("book_now")}{" "}
            {isHourlyRoom && (
              <img
                src="https://ik.imagekit.io/hotelzifyprod/f4ce4893-c0f4-4475-866b-c5dc54c7c760.svg"
                width={20}
                height={20}
                alt=""
              />
            )}
          </div>
        </div>
      </div>
      {!isSubscribed && !isGoogle && showFakePrice && (
        <div
          style={{
            width: "90%",
            margin: "10px auto",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            border: "1px solid #00d2ff",
            borderRadius: "8px",
            overflow: "hidden",
          }}
        >
          <p style={{ padding: "0 10px " }}>
            {t("unlock_additional_discount")}!
          </p>
          <button
            style={{
              background: "	#00d2ff",
              width: "80px",
              padding: "6px",
              borderRadius: "8px 0 0 8px",
              fontWeight: "600",
            }}
            onClick={() => {
              fireGtmEvent("subscribe_popup_shown", { position: "checkout" });
              onClose(true);
            }}
          >
            {t("unlock")} 🔓
          </button>
        </div>
      )}
      {/* {isOffer && !promoShown && isGoogle && (
        <div
          className="offerApplied"
          onClick={() => {
            setIsOffer(false);
            storageService.set("isPromoShown", true);
          }}
        >
          <div className="offerAppliedContainer">
            <Confetti width={1300} height={1300} numberOfPieces={1000} />
            <h2>
              {t("you_got")}{" "}
              {parseFloat(promotionSelected?.discount).toFixed(0)}%{t("off")}!!
            </h2>
            <p>{t("offer_ends_soon")}</p>
            <button
              onClick={() => {
                setIsOffer(false);
                storageService.set("isPromoShown", true);
              }}
            >
              {t("continue")}
            </button>
          </div>
        </div>
      )} */}
    </div>
  );
};

export default Checkout;
